import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-8 px-6 text-center" data-testid="not-found-page">
      <SEO title="404 — Vector Growth and Advisory" />
      <p className="font-mono text-xs uppercase tracking-[0.34em] text-neon/80">Error 404</p>
      <h1 className="font-display text-5xl font-extrabold tracking-tight sm:text-7xl">
        Off <span className="text-gradient">vector.</span>
      </h1>
      <p className="max-w-sm text-sm text-slate-500">
        This page drifted off course. Let's get you pointed back in the right direction.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="rounded-full border border-neon/40 px-7 py-3 font-mono text-xs uppercase tracking-[0.22em] text-neon transition-all duration-300 hover:bg-neon hover:text-white"
      >
        Back to base
      </Link>
    </div>
  );
}
